import { render, staticRenderFns } from "./ReferralItem.vue?vue&type=template&id=91622b0e&scoped=true&"
import script from "./ReferralItem.vue?vue&type=script&lang=js&"
export * from "./ReferralItem.vue?vue&type=script&lang=js&"
import style0 from "./ReferralItem.vue?vue&type=style&index=0&id=91622b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91622b0e",
  null
  
)

export default component.exports